import * as React from "react";
import { useMemo, useContext } from "react";
import { AdditionalContext } from "views/logic/ActionContext";
import useLicenseCheck from "license/useLicenseCheck";
import WatchlistStatusProvider from "watchlist/contexts/WatchlistStatusProvider";
import WatchlistStatusContext from "watchlist/contexts/WatchlistStatusContext";
const ExtendAdditionalContext = ({ children }) => {
  const licenseCheck = useLicenseCheck();
  const watchlistStatus = useContext(WatchlistStatusContext);
  const additionalContextValue = useMemo(
    () => ({
      licenseCheck,
      watchlistStatus
    }),
    [licenseCheck, watchlistStatus]
  );
  return /* @__PURE__ */ React.createElement(AdditionalContext.Provider, { value: additionalContextValue }, children);
};
const MessageDetailsAdditionalProvider = ({ children, message }) => /* @__PURE__ */ React.createElement(WatchlistStatusProvider, { message }, /* @__PURE__ */ React.createElement(ExtendAdditionalContext, null, children));
export default MessageDetailsAdditionalProvider;
